// File: src/components/common/StyledMenu.js
// -----------------------------------------------------
import React from 'react';
import { Menu } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Styled menu component
 */
const StyledMenu = ({ 
  anchorEl, 
  open, 
  onClose, 
  children, 
  ...props 
}) => (
  <Menu
    anchorEl={anchorEl}
    open={open !== undefined ? open : Boolean(anchorEl)}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    onClick={(e) => e.stopPropagation()}
    PaperProps={{
      elevation: 3,
      sx: { borderRadius: 2, mt: 0.5 }
    }}
    {...props}
  >
    {children}
  </Menu>
);

StyledMenu.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default StyledMenu;